import mutations from './mutations'

const state = {
    companyUuid: '',
    selection: [],//多选框
}

export default {
    state,
    mutations,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/company/index.js